import { configureStore } from "@reduxjs/toolkit";
import { patientApiSlice } from "./apis/patientApi";
import { patientVisitApiSlice } from "./apis/patientVisitApi";
import { patientLabsApiSlice } from "./apis/patientLabApi";
import { userApi } from "./apis/userApi";
import { patientPrescriptionApiSlice } from "./apis/patientPrescriptionApi";
import { appointmentApi } from "./apis/appointmentApi";
import { apiSlice } from "./apis/authApi";
import authReducer from "../pages/auth/authSlice";
import csrfReducer from "../pages/auth/csrfSlice";

// NOTE: patientApiSlice, patientVisitApiSlice, patientLabsApiSlice,
// patientPrescriptionApiSlice, userApi, and appointmentApi are all created via
// `apiSlice.injectEndpoints(...)`. They share the same reducerPath, reducer,
// and middleware as `apiSlice`, so we only register `apiSlice` here.
// The imports above are still required so their endpoints get injected.
void patientApiSlice;
void patientVisitApiSlice;
void patientLabsApiSlice;
void patientPrescriptionApiSlice;
void userApi;
void appointmentApi;

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        csrf: csrfReducer,
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat(apiSlice.middleware);
    },
    devTools: true,
});

//Redux Toolkit Query
export {
    useCreatePatientMutation,
    useGetPatientQuery,
    useUpdatePatientMutation,
    useGetPatientListQuery,
    useDeletePatientMutation,
    useSearchPatientsQuery,
    useGetPatientGenderCountQuery,
    useExportPatientDataMutation
} from "./apis/patientApi";

export {
    useCreateUserMutation,
    useDeleteUserMutation,
    useGetUserQuery,
    useGetUsersQuery,
    useUpdateUserMutation,
    useGetCurrentUserQuery,
    useUpdateCurrentUserMutation
} from "./apis/userApi";

export {
    useGetVisitsByPatientIdQuery,
    useGetPatientVisitQuery,
    useCreatePatientVisitMutation,
    useUpdatePatientVisitMutation,
    useDeletePatientVisitMutation,
    useGetVisitStatsQuery,
    useGetAllVisitsQuery,
    useSearchVisitsQuery
} from "./apis/patientVisitApi";

export { 
    useGetLabsByPatientIdQuery,
    useCreatePatientLabMutation,
    useDeletePatientLabMutation,
    useGetPatientLabQuery,
    useUpdatePatientLabMutation,
} from "./apis/patientLabApi";

export {
    useGetPrescriptionsByPatientIdQuery,
    useGetPatientPrescriptionQuery,
    useCreatePatientPrescriptionMutation,
    useUpdatePatientPrescriptionMutation,
    useDeletePatientPrescriptionMutation,
} from "./apis/patientPrescriptionApi";

export {
    useGetAppointmentsQuery,
    useGetAppointmentQuery,
    useCreateAppointmentMutation,
    useUpdateAppointmentMutation,
    useDeleteAppointmentMutation
} from "./apis/appointmentApi";
